import React from 'react';

const ChangePasswordForm = ({ onSubmit, onCancel, error, loading }) => {
  const [form, setForm] = React.useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="modal-form" autoComplete="off">
      <input
        type="password"
        placeholder="Current Password"
        name="currentPassword"
        value={form.currentPassword}
        onChange={handleChange}
        required
      />
      <input
        type="password"
        placeholder="New Password"
        name="newPassword"
        value={form.newPassword}
        onChange={handleChange}
        required
        minLength="6"
      />
      <input
        type="password"
        placeholder="Confirm New Password"
        name="confirmPassword"
        value={form.confirmPassword}
        onChange={handleChange}
        required
        minLength="6"
      />
      <div className="modal-actions">
        <button type="submit" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
        <button type="button" onClick={onCancel}>Cancel</button>
      </div>
      {error && <div className="error">{error}</div>}
    </form>
  );
};

export default ChangePasswordForm;
